import React from 'react';
import Particles from 'react-particles-js';
import particlesConfig from '../config/particlesConfig.json';
import arrow from '../assets/images/arrow.svg';
import Anime from 'react-anime';
import { Link } from 'react-scroll';

const Home = () => {

  const text = ['D', 'e', 'e', 'p', 'a', 'k', ' M', 'a', 'h', 'a', 'j', 'a', 'n'];

  return (
    <section id="home" className="home">
      <Particles className="particles" params={particlesConfig} />
      <div className="introduction">
        <div className="text">
          Hello, I'm 
          <Anime className="highlight" easing="easeInOutQuad"
            opacity={[0, 1]}
            duration={1500}
            delay={(el, i) => 150 * (i + 1)}>
            {text.map((t, i) => <span key={i}>{t}</span>)}
          </Anime>
          .<br />
          I'm full-stack web developer.
        </div>
        <Link activeClass="active" to="about" spy={true} smooth={true} duration={600} offset={-62}>
          <div className="viewBtn">
            View my work
            <img src={arrow} alt="" className="arrow" />
          </div>
        </Link>
      </div>
    </section>
  )
}

export default Home;
